// extracted by mini-css-extract-plugin
module.exports =  {"subscribeButton":"SubscribeButton-module_subscribeButton_af0bb","size-small":"SubscribeButton-module_size-small_b0626","star":"SubscribeButton-module_star_ee3a6"};